<template>
  <div class="payment-wechat-page">
      <div class="text-center" v-if="!isPay">
        <h1>网上支付提醒</h1>
        <p style="margin: 30px 0;"><i class="ico" :class="paymentIcon"></i></p>
        <p style="color: #666666;line-height: 22px;">支付完成前，请不要关闭此支付验证窗口。 </p>
        <p style="color: #666666;line-height: 22px;margin-bottom: 25px;">支付完成后，请根据您支付的情况点击下面按钮。</p>
        <el-button class="primary-reverse block" @click="close()">支付遇到问题</el-button>
        <el-button class="block" type="primary" @click="finish()">支付完成</el-button>
      </div>
      <div class="text-center" v-if="isPay">
        <h1>提示</h1>
        <p style="color: #666666;line-height: 22px;margin-bottom: 25px;">您的支付还未完成，请继续支付。</p>
        <el-button class="block" type="primary"  @click="submit()">确定</el-button>
      </div>
  </div>
</template>

<script>
import api from '../../services/api.js'
import { API_HOST } from '../../services/constant.js'
import os from '../../services/checkOs.js'
let _ = require('lodash')

export default {
  name: 'AddAddress',
  props: ['type', 'id', 'newWindow','orderNo','order'],
  components: {
  },
  computed: {
  },
  data () {
    return {
      API_HOST: API_HOST,
      url: null,
      payState: 0,
      amount: null,
      seconds: 5,
      checkPaidStatusInterval: null,
      redirctTimer: null,
      paymentIcon: null,
      isPay: false
    }
  },
  created () {
    let payTypes = {
      1: 'pay/credit/index.php',
      2: 'pay/wechat/index.php',
      3: 'pay/alipay/index.php',
      4: 'pay/paypal/index.php',
      12: 'pay/alphapay/online_web.php?channel=Alipay&currency=CNY',
      13: 'pay/alphapay/online_web.php?channel=UnionPay&currency=CNY'
    }

    if (this.type == 3) {
      this.paymentIcon = 'ico-alipay-40'
    } else if (this.type == 4) {
      this.paymentIcon = 'ico-paypal-40'
    }

    let payPath

    if (this.type == 3) {
      if(os.isAndroid || os.isPhone){
        payPath = 'pay/alipay_mobile/index.php'
      } else {
        payPath = 'pay/alipay/index.php'
      }
    } else {
      payPath = payTypes[this.type]
    }
    if(this.order.fee_adjustment_list.length == 0){
      if(this.type==12 || this.type==13){
        this.url = this.API_HOST + '/' + payPath + '&id=' + this.id+'&token=' + this.$localStorage.get('token')
      }
      else
        this.url = this.API_HOST + '/' + payPath + '?id=' + this.id + '&token=' + this.$localStorage.get('token')
    }
    if(this.order.fee_adjustment_list.length > 0){
      this.url = this.API_HOST + '/'+payPath+'?fee_adjustment_id=' + this.order.fee_adjustment_list[0].id + '&token=' + this.$localStorage.get('token')
    }
    if(this.type==12 || this.type==13){
      api.get(this, {
              path: this.url,
      })
        .then((res)=>{
          console.log('pey',res.body.result.paymentInfo.payUrl);
          //debugger;
          window.open(res.body.result.paymentInfo.payUrl)
        })
    }
    else
      this.newWindow.location.href = this.url

    // this.checkPaidStatus()
    // this.checkPaidStatusInterval = setInterval(() => {
    //   this.checkPaidStatus()
    // }, 2000)
  },
  methods: {
    async checkPaidStatus () {
      try {
        let { body } = await api.checkPaidStatus(this, {
          order_id: this.id,
          login_dialog: true
        })
        this.payState = body.result || 0

        if (this.payState != 0) {
          clearInterval(this.checkPaidStatusInterval)
          if(this.$route.path == '/customer/task/list'){
            this.$store.commit('clearTaskInfo')
            this.$router.go(0)
          }else{
            this.$store.commit('clearTaskInfo')
            this.$router.push({ path: '/Complete',query: {order_no:this.orderNo} })
          }
          
        }
      } catch(e) {
        console.log('this.newWindow', this.newWindow)
        setTimeout(() => {
          this.newWindow.close()
        }, 100)
        clearInterval(this.checkPaidStatusInterval)
        this.$emit('close')
        console.warn(e)
      }
    },
    finish () {
      if(this.payState != 0){
        clearInterval(this.checkPaidStatusInterval)
        this.$router.push({ path: '/Complete',query: {order_no:this.orderNo} })
        this.$emit('close')
      }else{
        this.isPay = true
      }
      
    },
    submit () {
      this.$emit('close')
    },
    close () {
      this.$emit('close')
    }
  },
  beforeDestroy: function() {
    clearInterval(this.checkPaidStatusInterval)
    clearInterval(this.redirctTimer)
  },
  watch: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.payment-wechat-page {
  padding-bottom: 45px;
}
h1 {
  height:25px;
  font-size:18px;
  font-family:PingFangSC-Regular;
  color:rgba(51,51,51,1);
  line-height:25px;
}
img {
  margin-top: 20px;
  border: 1px solid #DEE2EC;
  width: 220px;
  height: 220px;
}
.redirct {
  font-size:24px;
  font-family:PingFangSC-Regular;
  line-height:33px;
  margin-top: 54px;
  padding-bottom: 70px;

  a {
    font-size: 16px;
  }

  p {
    line-height: 24px;
    color: #888
  }
}
.primary-reverse {
  border-color: #0F66CF;
  color:#0F66CF;
  &:hover {
    background-color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/payment/Other.vue